export default __webpack_public_path__ + "static/media/2093-01.9b5bec6b.jpg";